import AgyleDialog from './agyleDialog';
import {useCallback} from 'react';
import InformationBox from '../other/informationBox';
import Typography from '@mui/material/Typography';
import {useDispatch, useSelector} from 'react-redux';
import {ctxShowUpdateWarning, setShowUpdateWarning} from '../../store/reducers/patientContext';
import {useTranslation} from 'react-i18next';

const AlertUpdatePatientData = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const dialogOpt = useSelector(ctxShowUpdateWarning);
    let text = '';

    // eslint-disable-next-line default-case
    switch (dialogOpt.type) {
        case 'histDemoUpt':
            text = 'Note: Editing in Step 2 – Demographics will update the current patient data, not historical information. Editing in Step 3 – Attendance will apply changes to historical attendance data.';
            break;
        case 'reviewDemoUpt':
            text = 'Note: Editing in Step 2 – Demographics will update the current patient data, not historical information. Proceeding to Step 3 and Step 4 will create a new attendance entry for the patient on the Whiteboard.';
            break;
        case 'histAttUpt':
            text = 'Note: Editing in Step 3 – Attendance will apply changes to historical attendance data.';
            break;
        case 'activeDemoUpt':
            text = 'Note: Editing in Step 2 – Demographics will update the current patient data.';
            break;
        case 'activeAttUpt':
            text = 'Note: Editing in Step 3 – Attendance will apply changes to current attendance data.';
            break;
        case 'activeDemoRefUpt':
            text = 'Note: Editing in Step 2 – Demographics will update the current patient data. Editing in Step 3 – Attendance will apply changes to current attendance data.';
            break;
    }

    const handleClose = useCallback(() => {
        dispatch(setShowUpdateWarning({
            open: false,
            type: null,
            onSubmit: null,
        }));
    }, []);

    if (!dialogOpt.type) return null;

    return (
        <AgyleDialog
            open={dialogOpt.open}
            onClose={handleClose}
            onSave={() => {
                if (dialogOpt.onSubmit) dialogOpt.onSubmit();
                handleClose();
            }}
            title={t('Warning')}
            fullWidth
            width="md"
        >
            <InformationBox type="warning">
                <Typography variant="h6">
                    {t(text)}
                </Typography>
            </InformationBox>
        </AgyleDialog>
    );
};

export default AlertUpdatePatientData;